import { UserFriendlyError } from '@util/UserFriendlyError';

/** Fetched data is not available. Could represent an error while fetching. */
type NotLoadedState = {
  /** The state is not being loaded/fetched. */
  loading: false;
  /** An error with a user friendly message for an error that occurred while loading/fetching the state. */
  error: UserFriendlyError | undefined;
};

/** Data is being fetched and is not yet available. */
type LoadingState = {
  /** The state is currently being loaded/fetched. */
  loading: true;
  /** `undefined` while loading/fetching the state. */
  error: undefined;
};

export const LOADING_STATE: LoadingState = { loading: true, error: undefined };

/** Fetched data is now available. */
export type LoadedState = {
  /** The state has successfully been loaded/fetched. */
  loading: false;
  /** No error occurred while loading/fetching the state. */
  error: undefined;
};

export const LOADED_STATE: LoadedState = { loading: false, error: undefined };

/** Loading and error state for store. */
export type LoadingAndErrorState = NotLoadedState | LoadingState | LoadedState;
